import React from 'react';

import { IProps } from './ScorePicker/ScorePicker';

export const Stats = ({ gross, net }: Partial<IProps>) => (
  <div className="score-stats">
    <div className="stat">{!!Number(gross) ? gross : '--'}</div>

    <div className="stat">{!!Number(net) ? net : '--'}</div>
  </div>
);
